/**
 * Knowledge Bases Hooks
 * Jotai atoms and hooks for knowledge base management
 */

import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { knowledgeBaseService } from '@/services';

// Query atoms
const knowledgeBasesQueryAtom = atomWithQuery(() => ({
  queryKey: ['knowledge-bases'],
  queryFn: knowledgeBaseService.getKnowledgeBases,
  staleTime: 60 * 1000
}));

// Hooks
export function useKnowledgeBases() {
  const [query] = useAtom(knowledgeBasesQueryAtom);
  return query;
}
